import { render, staticRenderFns } from "./SchemeNodeRules.vue?vue&type=template&id=678f7b50&scoped=true"
import script from "./SchemeNodeRules.vue?vue&type=script&lang=js"
export * from "./SchemeNodeRules.vue?vue&type=script&lang=js"
import style0 from "./SchemeNodeRules.vue?vue&type=style&index=0&id=678f7b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f7b50",
  null
  
)

export default component.exports